// ImageConverterService now lives in the visualization library (generic image
// conversions). Re-exported here so existing imports keep working.
//
// A bare `export { X } from 'pkg'` re-export of a value (not a type) can be
// silently elided under per-file isolated compilation, since the compiler
// can't prove X isn't type-only without cross-file knowledge - import then
// export avoids that.
import { ImageConverterService } from '@jax-data-science/sci-image-visualizer';
export { ImageConverterService };
